class CandidateConferenceController {
    /*@ngInject*/
    constructor($rootScope, meetingService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.meetingService = meetingService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    $onInit() {
        this.isLoading = true;
        this.$rootScope.hideNav = true;
        this._getScheduleDetails();
    }
    _getScheduleDetails() {
        this.meetingService.getScheduleDetails(this.scheduleId, (data) => {
            this.scheduleInfo = this.meetingService.getMassagedMeetingDetails(data);
            if (this.jobId && this.jobId == "") {
                this.jobId = data.jobId;
            }
            this.isLoading = false;
        }, error => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
        });
    }
}
CandidateConferenceController.$inject = ['$rootScope', 'meetingService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './candidate-conference.html';
import * as TEMPLATE from 'raw-loader!./candidate-conference.html';
export const CandidateConferenceComponent = {
    selector: 'candidateConference',
    component: {
        bindings: {
            scheduleId: '@',
            candidateId: '@',
            jobId: '@',
            jobMatchId: '@',
            workflowStep: '@',
            participantType: '@',
            type: '@',
            mode: '@'
        },
        template: TEMPLATE.default,
        // templateUrl: 'app/partials/candidateConference/candidateConference/candidate-conference.html',
        controller: CandidateConferenceController
    }
};
//# sourceMappingURL=candidate-conference.component.js.map